import React from 'react'
import { number, bool } from 'prop-types'
import { soompi } from 'scripts/api/SoompiApi'
import {getLang} from 'shared/i18n/react'

export default function Popular(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = { feed: this.props.placeHolders || null }
      this.getFeed = null
      this.lang = getLang()
    }

    static propTypes = {
      page: number.isRequired,
      limit: number.isRequired,
      showassoc: bool,
      showdate: bool
    }

    componentDidMount() {
      const { page, limit } = this.props
      this.getFeed = soompi.setLanguage(this.lang).getPopular({ limit, page })
      this.getFeed.promise.then((popular) => {
        if (popular.results) {
          this.setState({feed: popular.results})
        }
      })
    }

    componentWillUnmount() {
      if (this.getFeed) {
        this.getFeed.cancel()
      }
    }

    render() {
      const { feed } = this.state

      const settings = {
        data: feed,
        showassoc: this.props.showassoc,
        showdate: this.props.showdate
      }

      return (
        <Component {...this.state} {...this.props} {...settings} />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/content/Popular.jsx